import { useEffect, useState } from "react";
import { api, errMsg, euro } from "@/lib/api";
import { Field, Page } from "@/components/Layout";

const pivaOk = (p) => {
  if (!/^\d{11}$/.test(p)) return false;
  let s = 0;
  for (let i = 0; i < 10; i++) {
    let n = +p[i];
    if (i % 2) { n *= 2; if (n > 9) n -= 9; }
    s += n;
  }
  return (10 - (s % 10)) % 10 === +p[10];
};

const CAMPI = [
  ["ragione_sociale", "Ragione sociale", "sm:col-span-2"], ["piva", "Partita IVA", ""], ["codice_fiscale", "Codice fiscale", ""],
  ["pec", "PEC", ""], ["sdi", "Codice SDI (7 caratteri)", ""], ["indirizzo", "Indirizzo", "sm:col-span-2"],
  ["cap", "CAP", ""], ["citta", "Città", ""], ["provincia", "Provincia (sigla)", ""], ["telefono", "Telefono", ""],
  ["email", "Email", ""], ["password", "Password (min. 8)", ""],
];

export default function RegistratiOperatore() {
  const [f, setF] = useState(Object.fromEntries(CAMPI.map(([k]) => [k, ""]).concat([["categoria", ""], ["piano_id", ""]])));
  const [categorie, setCategorie] = useState([]);
  const [piani, setPiani] = useState([]);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/auth/categorie").then((r) => setCategorie(r.data));
    api.get("/pubblico/piani").then((r) => {
      setPiani(r.data);
      if (r.data.length) setF((p) => ({ ...p, piano_id: r.data[0].id }));
    });
  }, []);
  const pivaErr = f.piva.length === 11 && !pivaOk(f.piva);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    if (!f.pec && !f.sdi) return setErr("Inserisci la PEC o il codice SDI");
    if (!f.piano_id) return setErr("Seleziona un piano spazio");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/registrati-operatore", { ...f, pec: f.pec || null, sdi: f.sdi || null });
      window.location.href = data.checkout_url;
    } catch (e2) {
      setErr(errMsg(e2));
      setBusy(false);
    }
  };

  return (
    <Page className="max-w-3xl">
      <p className="caption">Per le attività</p>
      <h1 className="font-display text-4xl sm:text-5xl mt-2">Vendi le tue gift card</h1>
      <p className="text-[#786E65] mt-3 max-w-xl">Registra l'attività, scegli il piano spazio, configura la vetrina con 5 immagini e ricevi gli incassi direttamente sul tuo conto Stripe.</p>
      {(
        <form onSubmit={submit} className="card mt-8 grid sm:grid-cols-2 gap-5" data-testid="op-register-form">
          {CAMPI.map(([k, l, cls]) => (
            <div key={k} className={cls}>
              <Field label={l}>
                <input className="field" required={!["pec", "sdi"].includes(k)} type={k === "password" ? "password" : k === "email" ? "email" : "text"}
                  value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`op-reg-${k}-input`} />
              </Field>
              {k === "piva" && pivaErr && <p className="text-xs text-red-700 mt-1" data-testid="piva-error">Partita IVA non valida (checksum)</p>}
            </div>
          ))}
          <Field label="Categoria">
            <select required className="field" value={f.categoria} onChange={(e) => setF({ ...f, categoria: e.target.value })} data-testid="op-reg-categoria-select">
              <option value="">Seleziona…</option>
              {categorie.map((c) => <option key={c}>{c}</option>)}
            </select>
          </Field>
          <div className="sm:col-span-2">
            <span className="label">Piano spazio</span>
            <div className="grid sm:grid-cols-3 gap-3">
              {piani.map((p) => (
                <button type="button" key={p.id} onClick={() => setF({ ...f, piano_id: p.id })} data-testid={`op-reg-piano-${p.id}`}
                  className={`text-left rounded-xl border-2 p-4 transition-colors ${f.piano_id === p.id ? "border-[#7E5BAF] bg-[#7E5BAF]/5" : "border-[#E3D9F0] hover:border-[#7E5BAF]/50"}`}>
                  <p className="caption">{p.durata_mesi} mesi</p>
                  <p className="font-display text-xl mt-1">{p.nome}</p>
                  <p className="font-display text-2xl text-[#7E5BAF] mt-1">{euro(p.prezzo_cent)}</p>
                </button>
              ))}
            </div>
            <p className="text-xs text-[#786E65] mt-2">Dopo la registrazione vieni portato al pagamento sicuro con Stripe. Riceverai la fattura elettronica.</p>
          </div>
          {err && <p className="sm:col-span-2 text-sm text-red-700" data-testid="op-register-error">{err}</p>}
          <button className="btn-primary sm:col-span-2" disabled={busy || pivaErr || !f.piano_id} data-testid="op-register-submit-btn">{busy ? "Reindirizzamento al pagamento…" : "Registrati e paga il piano"}</button>
        </form>
      )}
    </Page>
  );
}
